import { useMemo } from "react";
import { useLocation } from "react-router-dom";

const BOOKING_PATH = "/booking";

interface UseIsExternalUsage {
  profileId?: number;
  bookingId?: number;
}

interface UseIsExternalUsageReturn {
  isExternalUsage: boolean;
  internalUsageEnabled: boolean;
  externalUsageEnabled: boolean;
}

export const useIsExternalUsage = ({
  profileId,
  bookingId
}: UseIsExternalUsage): UseIsExternalUsageReturn => {
  const { pathname } = useLocation();
  return useMemo(() => {
    const isExternalUsage = !pathname.startsWith(BOOKING_PATH) && !!profileId;
    const internalUsageEnabled = !isExternalUsage && !!bookingId;
    const externalUsageEnabled = isExternalUsage && !!bookingId && !!profileId;
    return {
      isExternalUsage,
      internalUsageEnabled,
      externalUsageEnabled
    };
  }, [pathname, profileId, bookingId]);
};
